import React, { useContext } from 'react';
import Select from '../../../components/form/Select';
import SiteContext from '../../../contexts/site/siteContext';
import { capitalizeFirstLetter } from '../../../services/utils';

const MenuSettings = () => {
    const siteContext = useContext(SiteContext);

    const changeCollectionMenu = (value: number) => {
        siteContext.updateSite({ ...siteContext.site, collection_menu_id: value });
    }

    const changeDeliveryMenu = (value: number) => {
        siteContext.updateSite({ ...siteContext.site, delivery_menu_id: value });
    }

    const changeCateringMenu = (value: number) => {
        siteContext.updateSite({ ...siteContext.site, catering_menu_id: value });
    }

    const changeVenuesMenu = (value: number) => {
        siteContext.updateSite({ ...siteContext.site, venues_menu_id: value });
    }

    const changeDineinMenu = (value: number) => {
        siteContext.updateSite({ ...siteContext.site, dine_in_menu_id: value });
    }

    if ( !siteContext.site || !siteContext.site.see_menus ) {
        return null;
    }

    let options = [];
    options = siteContext.site.available_menus.map((menu) => (
        <option key={menu.id + 'menu'} value={menu.id}>{menu.name}</option>
    ));

    options.unshift(<option key={null} disabled value="-1">Select menu</option>)

    return (
        <>
            <b className="text-muted">Menus</b>

            {siteContext.collectionEnabled ?
                <Select options={options} label={capitalizeFirstLetter("collection")} value={siteContext.site.collection_menu_id ?? '-1'} handleChange={changeCollectionMenu} />
                : null}
            {siteContext.deliveryEnabled ?
                <Select options={options} label={capitalizeFirstLetter("delivery")} value={siteContext.site.delivery_menu_id ?? '-1'} handleChange={changeDeliveryMenu} />
                : null}
            {siteContext.cateringEnabled ?
                <Select options={options} label={capitalizeFirstLetter("catering")} value={siteContext.site.catering_menu_id ?? '-1'} handleChange={changeCateringMenu} />
                : null}
            {siteContext.venuesEnabled ?
                <Select options={options} label={capitalizeFirstLetter("venues")} value={siteContext.site.venues_menu_id ?? '-1'} handleChange={changeVenuesMenu} />
                : null}
            {siteContext.dineinEnabled ?
                <Select options={options} label={capitalizeFirstLetter("dine-in")} value={siteContext.site.dine_in_menu_id ?? '-1'} handleChange={changeDineinMenu} />
                : null}

            <hr/>
        </>
    );
}

export default MenuSettings;
